import React from 'react';
import { 
  Compass, Brain, Sparkles, Users, Target, List, Zap, BarChart3, 
  Briefcase, Star, PieChart as PieChartIcon, ShieldCheck, 
  BrainCircuit, GraduationCap, Download, Loader2 
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';
import AIFormatter from '../AIFormatter';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const HollandReportUI = ({ report, currentAiAnalysis, handleAiGenerate, aiLoading }) => {
  const chartData = report.data.chartData || [];
  const top3Subjects = chartData.length > 0 
      ? [...chartData].sort((a, b) => b.A - a.A).slice(0, 3).map(i => i.subject) 
      : [];

  const dominantCode = top3Subjects.length > 0 ? top3Subjects[0] : "";

  // HOLLAND (RIASEC) DİNAMİK PROFİL MOTORU
  const hollandProfiles = {
      "Gerçekçi": {
          env: "Açık alanlar, atölyeler, laboratuvarlar, doğa ile iç içe veya teknik cihazların kullanıldığı pratik sahalar.",
          power: "Pratik zeka, alet ve makine kullanımı, el becerisi, fiziksel dayanıklılık ve somut problem çözme.",
          icon: Compass, color: "text-emerald-700", bg: "bg-emerald-50 border-emerald-200"
      },
      "Araştırmacı": {
          env: "Araştırma merkezleri, üniversiteler, kütüphaneler, teknoparklar veya bağımsız zihinsel çalışma alanları.",
          power: "Analitik düşünme, merak, karmaşık verileri yorumlama, bilimsel sorgulama ve rasyonel karar verme.",
          icon: Brain, color: "text-indigo-700", bg: "bg-indigo-50 border-indigo-200"
      },
      "Sanatsal": {
          env: "Stüdyolar, tiyatrolar, tasarım ofisleri, reklam ajansları veya esnek, kuralların esnek olduğu yaratıcı alanlar.",
          power: "Yaratıcılık, estetik bakış açısı, kendini ifade edebilme, yenilikçilik ve orijinal fikirler üretme.",
          icon: Sparkles, color: "text-purple-700", bg: "bg-purple-50 border-purple-200"
      },
      "Sosyal": {
          env: "Okullar, hastaneler, danışmanlık merkezleri, sivil toplum kuruluşları veya insan etkileşiminin yoğun olduğu yerler.",
          power: "Empati, iletişim, öğretme, dinleme, başkalarının gelişimine destek olma ve kriz anında sakinleştirme.",
          icon: Users, color: "text-blue-700", bg: "bg-blue-50 border-blue-200"
      },
      "Girişimci": {
          env: "Şirket yönetimleri, ticaret merkezleri, medya kuruluşları veya rekabetin ve iknanın ön planda olduğu ofisler.",
          power: "Liderlik, ikna kabiliyeti, risk alma, inisiyatif kullanma, organizasyon ve kriz yönetimi.",
          icon: Target, color: "text-orange-700", bg: "bg-orange-50 border-orange-200"
      },
      "Geleneksel": {
          env: "Bankalar, devlet daireleri, muhasebe ofisleri veya sınırları ve kuralları net olarak çizilmiş kurumsal yapılar.",
          power: "Düzen, sistem kurma, detaylara aşırı dikkat, veri işleme, güvenilirlik ve prosedürlere uyum.",
          icon: List, color: "text-slate-700", bg: "bg-slate-50 border-slate-200"
      }
  };

  const profile = hollandProfiles[dominantCode] || hollandProfiles["Araştırmacı"]; // Fallback
  const ProfileIcon = profile.icon;

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
        {/* ÜST BAŞLIK */}
        <div className="bg-slate-900 text-white p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900">
            <div className="flex items-center gap-4 print:gap-3">
                <div className="h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner bg-indigo-600 print:bg-indigo-700">
                    <Briefcase className="h-6 w-6 print:h-4 print:w-4 text-white"/>
                </div>
                <div>
                    <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Mesleki İlgi Envanteri Raporu</h2>
                    <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                        {report.meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {report.meta?.studentNo || "-"}
                    </span>
                </div>
            </div>
            <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
                <span className="text-2xl print:text-xl font-black block leading-none text-indigo-300 print:text-indigo-700">
                    {report.data.summary ? report.data.summary.split(': ')[1] : '---'}
                </span>
                <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Holland Kodu</span>
            </div>
        </div>

        {/* ANA SONUÇ METNİ */}
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 print:bg-none print:bg-indigo-50 p-5 print:p-4 rounded-2xl border border-indigo-100 print:border-indigo-200 shadow-sm">
            <h3 className="font-bold text-indigo-900 mb-2 print:mb-1.5 uppercase text-xs print:text-[11px] tracking-wider flex items-center">
                <Star className="h-4 w-4 print:h-3.5 print:w-3.5 mr-2"/> Analiz Sonucu
            </h3>
            <p className="text-sm print:text-[11.5px] font-medium text-slate-700 leading-relaxed print:leading-snug">"{report.data.analysis}"</p>
        </div>

        {/* SİMETRİK ORTA BÖLGE: GRAFİK VE MESLEK LİSTESİ */}
        <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
            {/* GRAFİK (BAR CHART) */}
            <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
                <h4 className="font-bold text-slate-800 mb-4 print:mb-2.5 text-sm print:text-[11px] uppercase flex items-center border-b pb-2 print:pb-1.5">
                    <PieChartIcon className="h-4 w-4 print:h-3.5 print:w-3.5 mr-2 text-indigo-500"/> İlgi Alanı Profili
                </h4>
                <div className="space-y-4 print:space-y-2.5 flex-1 flex flex-col justify-center">
                    {chartData.map((item, idx) => (
                    <div key={idx}>
                        <div className="flex justify-between items-end mb-1 print:mb-0.5 text-[10px] print:text-[9px] font-bold">
                            <span className="text-slate-600 uppercase tracking-wide">{item.subject}</span>
                            <span className={top3Subjects.includes(item.subject) ? "text-indigo-600 font-black" : "text-slate-500"}>{Math.round(item.A)} Puan</span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2 print:h-1.5 overflow-hidden print:border print:border-slate-300">
                            <div className={`h-full rounded-full print:bg-slate-700 ${top3Subjects.includes(item.subject) ? 'bg-indigo-600' : 'bg-slate-300'}`} style={{width: `${item.A}%`}}></div>
                        </div>
                    </div>
                    ))}
                </div>
            </div>

            {/* ÖNERİLEN MESLEKLER */}
            <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col print:border-slate-300">
                <h4 className="font-bold text-slate-800 mb-4 print:mb-3 text-sm print:text-[11px] uppercase flex items-center border-b pb-2 print:pb-1.5">
                    <Briefcase className="h-4 w-4 print:h-3.5 print:w-3.5 mr-2 text-green-600"/> Önerilen Meslek Dalları
                </h4>
                <div className="flex flex-wrap gap-2 print:gap-1.5 mb-4 print:mb-2">
                    {report.data.suggestedJobs && report.data.suggestedJobs.map((job, i) => (
                    <span key={i} className="bg-green-50 text-green-700 px-3 py-1.5 print:px-2 print:py-1 rounded-lg text-[11px] print:text-[9.5px] font-bold border border-green-100 print:border-green-200">
                        {job}
                    </span>
                    ))}
                    {(!report.data.suggestedJobs || report.data.suggestedJobs.length === 0) && <span className="text-xs text-slate-400">Öneri bulunamadı.</span>}
                </div>
                <div className="mt-auto bg-amber-50 p-3 print:p-2.5 rounded-lg border border-amber-100 print:border-amber-200 text-[10px] print:text-[9px] text-amber-800 leading-snug">
                    <strong>Not:</strong> Bu öneriler istatistiksel verilere dayanır. Tercih yapmadan önce detaylı araştırma önerilir.
                </div>
            </div>
        </div>

        {/* YENİ EKLENEN KARTLAR: ÇALIŞMA ORTAMI VE YETENEKLER */}
        <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
            <div className={`p-5 print:p-4 rounded-2xl border shadow-sm flex flex-col justify-center ${profile.bg}`}>
                <div className="flex items-center mb-1">
                    <ProfileIcon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${profile.color}`}/>
                    <span className="text-xs print:text-[10px] font-black uppercase tracking-widest text-slate-800">İdeal Çalışma Ortamı</span>
                </div>
                <div className={`text-sm print:text-[11.5px] font-black mb-1.5 mt-1 ${profile.color}`}>{dominantCode} Tipi Çalışma Alanları</div>
                <p className="text-[13px] print:text-[9.5px] font-medium text-slate-700 leading-snug">{profile.env}</p>
            </div>
            <div className={`p-5 print:p-4 rounded-2xl border shadow-sm flex flex-col justify-center ${profile.bg}`}>
                <div className="flex items-center mb-1">
                    <Zap className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${profile.color}`}/>
                    <span className="text-xs print:text-[10px] font-black uppercase tracking-widest text-slate-800">Kariyer Güç Alanı</span>
                </div>
                <div className={`text-sm print:text-[11.5px] font-black mb-1.5 mt-1 ${profile.color}`}>Temel Yetenek ve Beceriler</div>
                <p className="text-[13px] print:text-[9.5px] font-medium text-slate-700 leading-snug">{profile.power}</p>
            </div>
        </div>

        {/* SONRAKİ ADIMLAR */}
        <div className="bg-slate-50 border border-slate-200 print:border-slate-300 rounded-2xl p-5 print:p-4 shadow-sm avoid-break flex-1 mt-2">
            <h4 className="font-bold text-slate-800 mb-4 print:mb-3 text-sm print:text-[11px] uppercase flex items-center border-b pb-2 print:pb-1.5">
                <Compass className="h-4 w-4 print:h-3.5 print:w-3.5 mr-2 text-indigo-500"/> Yolculuk İçin Adımlar
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-4 print:gap-3">
                <div className="bg-white p-3.5 print:p-3 rounded-xl border border-slate-200 shadow-sm flex flex-col print:border-slate-300">
                    <div className="h-6 w-6 print:h-5 print:w-5 bg-indigo-100 text-indigo-700 rounded-md flex items-center justify-center font-black text-xs print:text-[10px] mb-2 print:mb-1.5">1</div>
                    <h5 className="font-bold text-xs print:text-[10.5px] text-slate-800 mb-1 print:mb-0.5">Meslek Araştırması</h5>
                    <p className="text-[10px] print:text-[8.5px] text-slate-500 leading-relaxed print:leading-snug">Önerilen mesleklerin çalışma koşullarını, aranan nitelikleri detaylıca araştırın.</p>
                </div>
                <div className="bg-white p-3.5 print:p-3 rounded-xl border border-slate-200 shadow-sm flex flex-col print:border-slate-300">
                    <div className="h-6 w-6 print:h-5 print:w-5 bg-indigo-100 text-indigo-700 rounded-md flex items-center justify-center font-black text-xs print:text-[10px] mb-2 print:mb-1.5">2</div>
                    <h5 className="font-bold text-xs print:text-[10.5px] text-slate-800 mb-1 print:mb-0.5">Yetenek Keşfi</h5>
                    <p className="text-[10px] print:text-[8.5px] text-slate-500 leading-relaxed print:leading-snug">Baskın olduğunuz alanlarda kendinizi deneyecek fırsatlar yaratın.</p>
                </div>
                <div className="bg-white p-3.5 print:p-3 rounded-xl border border-slate-200 shadow-sm flex flex-col print:border-slate-300">
                    <div className="h-6 w-6 print:h-5 print:w-5 bg-indigo-100 text-indigo-700 rounded-md flex items-center justify-center font-black text-xs print:text-[10px] mb-2 print:mb-1.5">3</div>
                    <h5 className="font-bold text-xs print:text-[10.5px] text-slate-800 mb-1 print:mb-0.5">Uzman Görüşmesi</h5>
                    <p className="text-[10px] print:text-[8.5px] text-slate-500 leading-relaxed print:leading-snug">Bu analizin sonuçlarını okul danışmanınızla birebir değerlendirin.</p>
                </div>
            </div>
        </div>

        {/* YAPAY ZEKA ALANI */}
        {!currentAiAnalysis ? (
            <div className="flex justify-center no-print mt-2">
                <button onClick={handleAiGenerate} disabled={aiLoading} className="w-full py-3 flex items-center justify-center text-xs font-bold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl transition-colors shadow-lg shadow-indigo-200">
                    {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Sparkles className="h-4 w-4 mr-2"/>}
                    {aiLoading ? "Yapay Zeka Analiz Ediyor..." : "Yapay Zeka ile Kariyer Analizi Yap"}
                </button>
            </div>
        ) : (
            <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-5 print:p-4 avoid-break shadow-sm mt-2">
                <div className="flex justify-between items-center mb-2 print:mb-1.5 border-b border-indigo-200 pb-2">
                    <h3 className="font-bold text-indigo-900 text-sm print:text-[11px] flex items-center uppercase tracking-wide">
                        <Briefcase className="h-4 w-4 print:h-3 print:w-3 mr-2 text-indigo-600"/> PDR Uzmanı / AI Kariyer Analizi
                    </h3>
                </div>
                <div className="print:text-black mt-2">
            <AIFormatter text={currentAiAnalysis} />
        </div>
            </div>
        )}
        
        <div className="text-[9px] print:text-[8px] text-slate-400 italic text-center mt-2 border-t border-slate-100 print:border-slate-200 pt-2 print:pt-1">
            * Bu envanter John Holland'ın Tipoloji Kuramı temel alınarak analiz edilmiştir.
        </div>
    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateHolland = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  const typeScores = {
      "Gerçekçi": 0, "Araştırmacı": 0, "Sanatsal": 0,
      "Sosyal": 0, "Girişimci": 0, "Geleneksel": 0
  };

  const dominantTypeCounts = {
      "Gerçekçi": 0, "Araştırmacı": 0, "Sanatsal": 0,
      "Sosyal": 0, "Girişimci": 0, "Geleneksel": 0
  };

  const classMap = {};

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || s.sınıf || s.class || s.grade || s.studentInfo?.sinif || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, topType: "" };
    }
    classMap[className].studentCount++;

    const chartData = s.reportData?.chartData || [];
    
    if (chartData.length > 0) {
        chartData.forEach(item => {
            if (typeScores[item.subject] !== undefined) {
                typeScores[item.subject] += item.A;
            }
        });

        const topSubject = [...chartData].sort((a, b) => b.A - a.A)[0];
        if (topSubject && dominantTypeCounts[topSubject.subject] !== undefined) {
            dominantTypeCounts[topSubject.subject]++;
            
            if (!classMap[className].typeCounts) classMap[className].typeCounts = {};
            if (!classMap[className].typeCounts[topSubject.subject]) classMap[className].typeCounts[topSubject.subject] = 0;
            classMap[className].typeCounts[topSubject.subject]++;
        }
    }
  });

 const avgScores = Object.entries(typeScores).map(([subject, totalScore]) => {
      const avg = total > 0 ? (totalScore / total) : 0;
      return {
          subject,
          avgScore: avg.toFixed(1),
          percent: Math.round(avg)
      };
  }).sort((a, b) => b.avgScore - a.avgScore);

  const dominantTypesList = Object.entries(dominantTypeCounts).map(([subject, count]) => ({
      subject,
      count,
      percent: total > 0 ? Math.round((count / total) * 100) : 0
  })).sort((a, b) => b.count - a.count);

  const topDominant = dominantTypesList[0];
  const secondDominant = dominantTypesList[1];
  const thirdDominant = dominantTypesList[2];

  const classStats = Object.values(classMap).map(c => {
      let topType = "Belirsiz";
      let maxCount = 0;
      if (c.typeCounts) {
          Object.entries(c.typeCounts).forEach(([type, count]) => {
              if (count > maxCount) {
                  maxCount = count;
                  topType = type;
              }
          });
      }
      return { ...c, topType, maxCount, percentInClass: c.studentCount > 0 ? Math.round((maxCount / c.studentCount) * 100) : 0 };
  }).sort((a, b) => b.studentCount - a.studentCount); 

  return { total, avgScores, dominantTypesList, topDominant, secondDominant, thirdDominant, classStats };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const HollandKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateHolland(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const typeStyles = {
      "Gerçekçi": { color: "text-emerald-700", bg: "bg-emerald-50 print:bg-white border-emerald-200 print:border-slate-300", bar: "bg-emerald-500", icon: Compass },
      "Araştırmacı": { color: "text-indigo-700", bg: "bg-indigo-50 print:bg-white border-indigo-200 print:border-slate-300", bar: "bg-indigo-500", icon: Brain },
      "Sanatsal": { color: "text-purple-700", bg: "bg-purple-50 print:bg-white border-purple-200 print:border-slate-300", bar: "bg-purple-500", icon: Sparkles },
      "Sosyal": { color: "text-blue-700", bg: "bg-blue-50 print:bg-white border-blue-200 print:border-slate-300", bar: "bg-blue-500", icon: Users },
      "Girişimci": { color: "text-orange-700", bg: "bg-orange-50 print:bg-white border-orange-200 print:border-slate-300", bar: "bg-orange-500", icon: Target },
      "Geleneksel": { color: "text-slate-700", bg: "bg-slate-50 print:bg-white border-slate-200 print:border-slate-300", bar: "bg-slate-500", icon: List }
  };

  const TopIcon = typeStyles[data.topDominant.subject]?.icon || Star;
  const topColor = typeStyles[data.topDominant.subject]?.color || "text-slate-800";

  let clubRecommendations = [];
  if (data.topDominant.subject === "Araştırmacı" || data.topDominant.subject === "Gerçekçi") {
      clubRecommendations = ["TÜBİTAK/Teknofest Proje Grupları", "Mekatronik ve Robotik Kulübü", "Doğa ve Doğa Sporları Kulübü"];
  } else if (data.topDominant.subject === "Sosyal" || data.topDominant.subject === "Girişimci") {
      clubRecommendations = ["Münazara ve Liderlik Kulübü", "Sosyal Yardımlaşma ve Kızılay", "Genç Girişimciler Kulübü"];
  } else {
      clubRecommendations = ["Tiyatro ve Yaratıcı Drama", "Görsel Sanatlar ve Tasarım", "Medya ve İletişim Kulübü"];
  }

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('holland-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="holland-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        
        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - KURUMSAL KARİYER YÖNELİMİ         */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className="bg-slate-900 text-white p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900 shrink-0 avoid-break">
            <div className="flex items-center gap-5 print:gap-3">
              <div className="h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner bg-indigo-600 print:bg-indigo-700">
                <Briefcase className="h-7 w-7 print:h-5 print:w-5 text-white"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   HOLLAND MESLEKİ İLGİ VE KARİYER HARİTASI
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className="text-3xl print:text-xl font-black block leading-none text-indigo-300 print:text-indigo-700">{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center ${typeStyles[data.topDominant.subject]?.bg}`}>
              <div className="flex items-center mb-1.5">
                 <TopIcon className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${topColor}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${topColor}`}>1. Baskın Eğilim</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${topColor}`}>
                 {data.topDominant.subject} <span className="text-xs print:text-[9px] font-medium opacity-70 uppercase">(%{data.topDominant.percent})</span>
              </p>
            </div>
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center ${typeStyles[data.secondDominant.subject]?.bg || 'bg-slate-50'}`}>
              <div className="flex items-center mb-1.5">
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${typeStyles[data.secondDominant.subject]?.color || 'text-slate-700'}`}>2. İkincil Eğilim</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${typeStyles[data.secondDominant.subject]?.color || 'text-slate-800'}`}>
                 {data.secondDominant.subject} <span className="text-xs print:text-[9px] font-medium opacity-70 uppercase">(%{data.secondDominant.percent})</span>
              </p>
            </div>
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center ${typeStyles[data.thirdDominant.subject]?.bg || 'bg-slate-50'}`}>
              <div className="flex items-center mb-1.5">
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${typeStyles[data.thirdDominant.subject]?.color || 'text-slate-700'}`}>3. Destekleyici Eğilim</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${typeStyles[data.thirdDominant.subject]?.color || 'text-slate-800'}`}>
                 {data.thirdDominant.subject} <span className="text-xs print:text-[9px] font-medium opacity-70 uppercase">(%{data.thirdDominant.percent})</span>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
            
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-blue-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-blue-200 print:border-slate-200 pb-1.5">
                 <Users className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> Sınıf Bazlı Kariyer Kimliği
               </h3>
               <div className="space-y-2 print:space-y-1 mt-1">
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">En Kalabalık Grup: {data.classStats[0] ? data.classStats[0].name : '-'}</span>
                    <p className="text-sm print:text-[10px] font-black text-slate-800 leading-tight truncate">
                      Baskın Tip: {data.classStats[0] ? data.classStats[0].topType : 'Belirsiz'}
                      {data.classStats[0] && <span className="text-[10px] print:text-[8px] font-bold text-indigo-600 ml-1">(%{data.classStats[0].percentInClass})</span>}
                    </p>
                  </div>
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">İkinci Grup: {data.classStats[1] ? data.classStats[1].name : '-'}</span>
                    <p className="text-xs print:text-[9px] font-black text-slate-700 leading-tight truncate">
                      Baskın Tip: {data.classStats[1] ? data.classStats[1].topType : 'Belirsiz'}
                      {data.classStats[1] && <span className="text-[10px] print:text-[8px] font-bold text-indigo-500 ml-1">(%{data.classStats[1].percentInClass})</span>}
                    </p>
                  </div>
               </div>
            </div>

            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-purple-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-purple-200 print:border-slate-200 pb-1.5">
                 <BrainCircuit className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-purple-600"/> Kurumsal Kariyer DNA'sı
               </h3>
               
               <div className="flex items-center justify-center my-2">
                   <div className="text-center px-4 py-2 bg-white print:bg-slate-100 rounded-xl border border-purple-100 print:border-slate-200 shadow-inner">
                       <span className="text-2xl print:text-xl font-black tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 print:text-black">
                           {data.topDominant.subject.substring(0,1)}{data.secondDominant.subject.substring(0,1)}{data.thirdDominant.subject.substring(0,1)}
                       </span>
                   </div>
               </div>
               
               <p className="text-[10px] print:text-[8px] text-slate-700 leading-snug font-medium mt-1 text-center line-clamp-2">
                 Bu kurum; yeteneklerini <strong>{data.topDominant.subject.toLowerCase()}</strong> ve <strong>{data.secondDominant.subject.toLowerCase()}</strong> alanlarında sergilemeye yatkın bir profile sahiptir.
               </p>
            </div>

            <div className="col-span-2 bg-amber-50 p-4 print:p-3.5 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm print:shadow-none flex flex-col justify-center">
               <div className="flex justify-between items-center border-b border-amber-200 print:border-slate-200 pb-2 mb-2.5">
                 <h3 className="font-bold text-amber-900 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <Target className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-amber-600"/> Yöneltme İçin Öncelikli Kulüp ve Etkinlikler
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-amber-700 print:text-slate-500 italic">Okul İklimine En Uygun</span>
               </div>
               
               <div className="flex flex-wrap gap-2 print:gap-1.5 mt-1">
                 {clubRecommendations.map((club, idx) => (
                   <span key={idx} className="bg-white print:bg-amber-50/40 text-amber-700 print:text-slate-800 px-3 py-1.5 print:px-2 print:py-1 rounded-lg text-[11px] print:text-[9.5px] font-bold border border-amber-200 print:border-amber-200 shadow-sm print:shadow-none">
                      {club}
                   </span>
                 ))}
               </div>
            </div>

            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <BarChart3 className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Okul Genel İlgi Dağılımı (Ortalama Puanlar)
                 </h3><span className="text-[10px] print:text-[8px] text-slate-500 italic">Değerler Yüzdelik Orandır (%100)</span>
               </div>
               
               <div className="space-y-3 print:space-y-2">
                  {data.avgScores.map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.subject}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">{dim.avgScore} <span className="text-[10px] print:text-[7.5px] text-slate-500 font-medium">Puan</span></span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                       <div className={`h-full rounded-full print:bg-slate-600 ${typeStyles[dim.subject]?.bar || 'bg-slate-500'}`} style={{ width: `${dim.percent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>

          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
             
             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] bg-slate-50 border-slate-200 print:bg-white print:border-slate-300`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <Compass className="h-5 w-5 print:h-4 print:w-4 mr-2 text-indigo-600"/>
                  PDR Servisi Yöneltme Planı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className="text-sm print:text-[11px] font-black leading-tight mb-1.5 text-indigo-800">
                      Grup Rehberliği ve Geziler
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      Baskın Holland tiplerine göre öğrencilerin vizyonunu açacak ve hedef belirlemelerini kolaylaştıracak stratejiler:
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                      <li className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className="mr-1.5 font-black text-indigo-600">•</span> Kurumun baskın eğilimine ({data.topDominant.subject}) uygun üniversite ve fabrika/ofis gezileri düzenlenmesi.
                      </li>
                      <li className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className="mr-1.5 font-black text-indigo-600">•</span> YKS/LGS hedeflerini somutlaştırmak için 'Kariyer Günleri'nde bu meslek profesyonellerinin davet edilmesi.
                      </li>
                      <li className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className="mr-1.5 font-black text-indigo-600">•</span> Puanı birbirine yakın kararsız öğrencilerle (Düz profil) bireysel kariyer danışmanlığı seansları yapılması.
                      </li>
                  </ul>
                </div>
             </div>

             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] bg-slate-50 border-slate-200 print:bg-white print:border-slate-300`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <ShieldCheck className="h-5 w-5 print:h-4 print:w-4 mr-2 text-teal-600"/>
                  Okul İdaresi & Sınıf Öğretmeni
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className="text-sm print:text-[11px] font-black leading-tight mb-1.5 text-teal-800">
                      Akademik Motivasyon Arttırıcılar
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      Ders başarısını artırmak için öğretmenlerin uygulayabileceği öğrenme stilleri ve idari destekler:
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                      <li className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className="mr-1.5 font-black text-teal-600">•</span> Sınıf öğretmenlerinin, öğrencilerin baskın ilgi alanlarını (Proje yapma, Sosyal etkinlik vb.) ders içi görevlerde kullanması.
                      </li>
                      <li className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className="mr-1.5 font-black text-teal-600">•</span> İdarenin, Destekleme ve Yetiştirme Kurslarını (DYK) açarken öğrencilerin bu mesleki yönelimlerini göz önüne alması.
                      </li>
                      <li className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className="mr-1.5 font-black text-teal-600">•</span> Veli toplantılarında sadece notların değil, çocuğun 'Kariyer DNA'sının ve yeteneklerinin de gündem yapılması.
                      </li>
                  </ul>
                </div>
             </div>

          </div>

        </div>
        {/* ==================== 1. SAYFA SONU ==================== */}

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Kurumsal Mesleki Yöneltme ve Kariyer Planı
              </h3>
              <button onClick={() => onGenerateAI(title, data.avgScores)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>

          <div className="hidden print:flex justify-between mt-10 pt-4 text-[10px] text-black px-12 shrink-0 border-t border-slate-300">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-16">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-16">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};